export const percentOf = (rate: number | null): number => rate == null ? 0 : Math.round(rate * 100)

export const rateLabel = (rate: number | null): string => rate == null ? 'N/A' : `${percentOf(rate)}%`
